class Validations {
  static isEmpty = (value) => {
    if (!value || value === '') return true;
    return false;
  }
}

export default Validations;